module.exports = __webpack_public_path__ + "img/school.1d6703f5.png";